import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router, ActivatedRoute } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { ShipDetailService } from '../../../service/ship-detail/ship-detail.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'wa3020',
  templateUrl: 'wa3020.component.html',
  styleUrls: ['wa3020.component.scss']
})
export class Wa3020Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA3020:出荷指示詳細照会';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @ViewChild('gridView')
  gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private isEnableClearFilterButton = false;

  /** pagination */
  private totalCount = 0;
  private currentPage = 0;
  private maxPage = 0;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  //search block
  private isShowSearchBlock = true;
  private searchKeyItemcode = null;
  private searchKeyShipTx = null;
  private startDate = null;
  private endDate = null;

  private paginationGetRowCount = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private shipDetailService: ShipDetailService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.scrollArrowCustomVarietyValue = -111;
    this.gridOptions = <GridOptions>{
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      shohwLoadingOverlay: true,
      pagination: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3020_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.fixedDateFilterInput();
        //this.gridHelper.hidePaginiation();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorInfo = '';
      },
      onRowDataChanged: () => {
        this.gridHelper.onRowDataChanged();
        this.errorInfo = '';
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.gridOptions.api.paginationSetPageSize(this.totalCount);

        this.maxPage = this.gridOptions.api.paginationGetTotalPages();
        this.currentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'col1Scroll:255',
        suppressMenu: true,
        width: 8,
        cellClass: ['tc', 'cellclass'],
        hide: true,
        pinned: 'left',
        cellStyle: function (params) {
          //ステータス色変化
          if (params.data.stshipTx == '欠品') {
            return { backgroundColor: 'rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.2)' };
          } else if (params.data.stshipTx == '未引当') {
            return { backgroundColor: 'rgba(235,153,175,0.2)', color: 'rgba(235,153,175,0.2)' };
          } else if (params.data.stshipTx == '引当完了') {
            return { backgroundColor: 'rgba(227,230,87,0.2)', color: 'rgba(227,230,87,0.2)' };
          } else if (params.data.stshipTx == '出荷完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '出荷番号',
        field: 'shipnoCd',
        width: this.getColumnWidth('shipnoCd', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '出荷ステータス',
        field: 'stshipTx',
        width: this.getColumnWidth('stshipTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tc', 'cellclass'],
        cellStyle: function (params) {
          //ステータス色変化
          if (params.value == '欠品') {
            return { backgroundColor: 'rgba(255,255,255,0.2)', color: 'rgba(217,59,59,1)' };
          } else if (params.value == '未引当') {
            return { backgroundColor: 'rgba(235,153,175,0.2)' };
          } else if (params.value == '引当完了') {
            return { backgroundColor: 'rgba(227,230,87,0.2)' };
          } else if (params.value == '出荷完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      /*
      {
        headerName: '出荷指示ヘッダID',
        field: 'shiphId',
        sort: 'desc',
        width: this.getColumnWidth('shiphId', 100),
        cellClass: 'rightaligned'
      },
      */
      {
        headerName: '出荷指示日',
        field: 'shipDt',
        width: this.getColumnWidth('shipDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先名',
        field: 'dtnameTx',
        width: this.getColumnWidth('dtnameTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先郵便番号',
        field: 'dtpostalCd',
        width: this.getColumnWidth('dtpostalCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先住所1',
        field: 'dtaddress1Tx',
        width: this.getColumnWidth('dtaddress1Tx', 300),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先住所2',
        field: 'dtaddress2Tx',
        width: this.getColumnWidth('dtaddress2Tx', 250),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先電話番号',
        field: 'dttelTx',
        width: this.getColumnWidth('dttelTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ケース数',
        field: 'caseNr',
        width: this.getColumnWidth('caseNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ケース入数',
        field: 'caseamountNr',
        width: this.getColumnWidth('caseamountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'インナーケース数',
        field: 'innerNr',
        width: this.getColumnWidth('innerNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'インナーケース入数',
        field: 'inneramountNr',
        width: this.getColumnWidth('inneramountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'バラ数',
        field: 'baraNr',
        width: this.getColumnWidth('baraNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '数量',
        field: 'pcsNr',
        width: this.getColumnWidth('pcsNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '出荷時摘要',
        headerTooltip: '出荷時摘要',
        field: 'memodetTx',
        width: this.getColumnWidth('memodetTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票届先商品コード',
        field: 'invdtitemCd',
        width: this.getColumnWidth('invdtitemCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票届先商品名称',
        field: 'invdtitemTx',
        width: this.getColumnWidth('invdtitemTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票色/入数',
        field: 'invcolorTx',
        width: this.getColumnWidth('invcolorTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票サイズ/ケース',
        field: 'invsizeTx',
        width: this.getColumnWidth('invsizeTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票単位',
        field: 'invunitTx',
        width: this.getColumnWidth('invunitTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票引合',
        field: 'invinquiryTx',
        width: this.getColumnWidth('invinquiryTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票引合区分',
        field: 'invtypeinquiryTx',
        width: this.getColumnWidth('invtypeinquiryTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票原単価',
        field: 'invunitcostNr',
        width: this.getColumnWidth('invunitcostNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '伝票売単価',
        field: 'invunitpriceNr',
        width: this.getColumnWidth('invunitpriceNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      /*
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        hide: true
      },
      */
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      } /*,
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        hide: true
      }*/
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.gridHelper.onViewportScrollListener = () => {
      this.fixedDateFilterInput();
    };
  }

  fixedDateFilterInput() {
    var dateFilter = this.gridView.nativeElement.querySelector('.ag-filter-filter');
    if (dateFilter == null) return;
    dateFilter.classList.add('ag-floating-filter-input');
    dateFilter.placeholder = '';
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3020_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3020_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa3020_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    this.gridOptions.api.setRowData([]);
    var date = new Date();
    //this.onSubmit();

    setTimeout(() => {
      this.startDate = date.getFullYear() + '-' + this.pad(date.getMonth() + 1, 2) + '-' + this.pad(date.getDate(), 2);
      this.endDate = date.getFullYear() + '-' + this.pad(date.getMonth() + 1, 2) + '-' + this.pad(date.getDate() + 1, 2);
    }, 500);
  }

  pad(num, totalStringSize) {
    var asString = num + '';
    while (asString.length < totalStringSize) asString = '0' + asString;
    return asString;
  }

  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.gridOptions.api.deselectAll();
    }
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    this.errorInfo = '';

    if (this.ownerId == null && this.ownerId !== undefined) {
      this.rowData = [];
      this.gridOptions.api.hideOverlay();
      return;
    }
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    const shiphId = sessionStorage.getItem('wa3010_shiphId');
    this.shipDetailService
      .get(this.ownerId, shiphId, this.startDate, this.endDate)
      .then(outputJson => {
        console.log(outputJson);
        this.rowData = outputJson.shipdirects;
        setTimeout(() => {
          this.searchByKey();
          this.gridOptions.api.hideOverlay();
          this.working = false;
        }, 300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  toggleSearchBlock() {
    this.errorInfo = '';
    this.isShowSearchBlock = !this.isShowSearchBlock;
    setTimeout(() => {
      this.gridHelper.renderScrollArrow();
    }, 200);
  }

  clearSearchKey() {
    this.errorInfo = '';
    this.searchKeyItemcode = null;
    this.searchKeyShipTx = null;
    this.startDate = null;
    this.endDate = null;
  }

  searchByKey() {
    var filters = {};
    if (this.searchKeyItemcode != null && this.searchKeyItemcode.length > 0) {
      filters['itemCd'] = {
        type: 'contains',
        filter: this.searchKeyItemcode
      };
    }

    if (this.searchKeyShipTx != null && this.searchKeyShipTx.length > 0) {
      filters['shipnoCd'] = {
        type: 'contains',
        filter: this.searchKeyShipTx
      };
    }
    this.gridApi.api.setFilterModel(null);
    if (Object.getOwnPropertyNames(filters).length == 0) return;
    console.log(filters);
    this.gridApi.api.setFilterModel(filters);
  }

  clearFilter() {
    this.gridOptions.api.setFilterModel(null);
  }

  clearAndSubmit() {
    this.clearFilter();
    this.onSubmit();
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3020/wa3020.component.ts